import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=4e081e86&scoped=true"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=4e081e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e081e86",
  null
  
)

export default component.exports